const LAY_DANH_SACH_CAP_DON_VI_THANH_CONG = (state, danhSachCapDonVi) => {
  state.danhSachCapDonVi = danhSachCapDonVi;
};

const LAY_DANH_SACH_CAP_DON_VI_PAGING_THANH_CONG = (state, danhSachCapDonViPaging) => {
  state.danhSachCapDonViPaging = danhSachCapDonViPaging;
};

const THEM_MOI_CAP_DON_VI_THANH_CONG = (state, CapDonVi) => {
  state.danhSachCapDonVi.push(CapDonVi);
};

const SUA_CAP_DON_VI_THANH_CONG = (state, CapDonVi) => {
  const editItemIndex = state.danhSachCapDonVi.findIndex(
    obj => obj.id === parseInt(CapDonVi.id)
  );
  state.danhSachCapDonVi[editItemIndex] = Object.assign(
    state.danhSachCapDonVi[editItemIndex],
    CapDonVi
  );
};

export default {
  LAY_DANH_SACH_CAP_DON_VI_THANH_CONG,
  LAY_DANH_SACH_CAP_DON_VI_PAGING_THANH_CONG,
  THEM_MOI_CAP_DON_VI_THANH_CONG,
  SUA_CAP_DON_VI_THANH_CONG
};
